/**
 * @generated SignedSource<<dcc8d6470279fd94027ab4071b7fa6a3>>
 * @relayHash 71aea56009f2d8825f482e2ad891e13a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2b481a2dbcebbbb459540b8b7762b7ab1be5f33c38ad906c71e0a2286e31ece

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_cascadingSelectSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
};
export type cascadingSelect_cascadingSelectSearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment">;
};
export type cascadingSelect_cascadingSelectSearchRefetchQuery = {
  response: cascadingSelect_cascadingSelectSearchRefetchQuery$data;
  variables: cascadingSelect_cascadingSelectSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "optionId"
  },
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraCascadingOptionsConnection",
                "kind": "LinkedField",
                "name": "cascadingOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCascadingOptionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraCascadingOptions",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "parentOptionValue",
                            "plural": false,
                            "selections": (v7/*: any*/)
                          },
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "childOptionValues",
                            "plural": true,
                            "selections": (v7/*: any*/)
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v5/*: any*/),
                "handle": "connection",
                "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                "kind": "LinkedHandle",
                "name": "cascadingOptions"
              }
            ],
            "type": "JiraCascadingSelectField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "a2b481a2dbcebbbb459540b8b7762b7ab1be5f33c38ad906c71e0a2286e31ece",
    "metadata": {},
    "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "861857f405fb6492f7093672a20e5a50";

export default node;
